module.exports = __webpack_public_path__ + "img/sticker-2-0.1082752a.svg";